var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 387936292"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 558",
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "white",
    stroke: "#F9E64D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Dashboard",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 17.8571V24.5447C28 25.6493 27.1046 26.5447 26 26.5447H16C14.8954 26.5447 14 25.6493 14 24.5447V17.8571C14 17.1394 14.3846 16.4767 15.0077 16.1207L20.0077 13.2635C20.6226 12.9122 21.3774 12.9122 21.9923 13.2635L26.9923 16.1207C27.6154 16.4767 28 17.1394 28 17.8571ZM13 17.8571C13 16.7806 13.5769 15.7865 14.5116 15.2524L19.5116 12.3953C20.4339 11.8682 21.5661 11.8682 22.4884 12.3953L27.4884 15.2524C28.4231 15.7865 29 16.7806 29 17.8571V24.5447C29 26.2016 27.6569 27.5447 26 27.5447H16C14.3431 27.5447 13 26.2016 13 24.5447V17.8571ZM25.424 18.3096C25.2776 18.5437 24.9692 18.6149 24.735 18.4686L21 16.1342L17.265 18.4686C17.0308 18.6149 16.7224 18.5437 16.576 18.3096C16.4296 18.0754 16.5008 17.7669 16.735 17.6206L20.735 15.1206C20.8971 15.0192 21.1029 15.0192 21.265 15.1206L25.265 17.6206C25.4992 17.7669 25.5704 18.0754 25.424 18.3096ZM23.5 24.0446C23.5 24.3207 23.2761 24.5446 23 24.5446H21H19C18.7239 24.5446 18.5 24.3207 18.5 24.0446C18.5 23.7684 18.7239 23.5446 19 23.5446H21H23C23.2761 23.5446 23.5 23.7684 23.5 24.0446Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.7a82a14ca50423fb31a5e1148dab75b4.svg";
export { ForwardRef as ReactComponent };